// extracted by mini-css-extract-plugin
export default {"field":"UserAddStep_field__mPVtc","text":"UserAddStep_text__12EnT"};